import { RouterProvider } from "react-router-dom";

import { AuthProvider } from "@/auth";
import { LocaleProvider } from "@/localization";
import { TeamsProvider } from "@/teams";
import router from "@/router";

import "@/styles/index.scss";

export default function App() {
  return (
    <TeamsProvider>
      <LocaleProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </LocaleProvider>
    </TeamsProvider>
  );
}
